import React, { useContext } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";

export const RouterContext = React.createContext({});

//CustomBrowserRouter lets us recreate a RouterContext rather than using the private react-router one
export const CustomBrowserRouter = ({ children }) => (
  <BrowserRouter>
    <LastLocationProvider>
      <Route>{routeProps => <RouterContext.Provider value={routeProps}>{children}</RouterContext.Provider>}</Route>
    </LastLocationProvider>
  </BrowserRouter>
);

export const useLocation = () => {
  const context = useContext(RouterContext);
  return context.location;
};

export function useMatch() {
  const context = useContext(RouterContext);
  return context.match;
}

export function useParams() {
  const context = useContext(RouterContext);
  return context.match.params;
}

export const useHistory = () => {
  const context = useContext(RouterContext);
  return context.history;
};
